import { gql } from "@apollo/client/core";

// 查询所有学校
export const GET_SCHOOLS = gql`
  query GetSchools {
    schools {
      school_id
      name
    }
  }
`;

// 查询所有学生
export const GET_STUDENTS = gql`
  query GetStudents {
    students {
      student_id
      name
      status
      birthday
    }
  }
`;

// 查询单个学生
export const GET_STUDENT = gql`
  query GetStudent($student_id: ID!) {
    student(student_id: $student_id) {
      student_id
      name
      status
      birthday
    }
  }
`;

// 创建学生
export const CREATE_STUDENT = gql`
  mutation CreateStudent($name: String!, $status: StudentStatus!, $birthday: Date) {
    createStudent(name: $name, status: $status, birthday: $birthday) {
      name
      status,
      birthday
    }
  }
`;

// 更新学生
export const UPDATE_STUDENT = gql`
  mutation UpdateStudent($student_id: ID!, $name: String, $status: StudentStatus, $birthday: Date) {
    updateStudent(student_id: $student_id, name: $name, status: $status, birthday: $birthday) {
      student_id
      name
      status, 
      birthday
    }
  }
`;

// 删除学生
export const DELETE_STUDENT = gql`
  mutation DeleteStudent($student_id: ID!) {
    deleteStudent(student_id: $student_id) {
      student_id
    }
  }
`;

// 查询所有课程
export const GET_COURSES = gql`
  query GetCourses {
    courses {
      course_id
      name
      subject
      grade
      school_year
      status
      on_monday
      on_tuesday
      on_wednesday
      on_thursday
      on_friday
      on_saturday
      on_sunday
    } 
  }
`;

// 查询单个课程
export const GET_COURSE = gql`
  query GetCourse($course_id: ID!) {
    course(course_id: $course_id) {
      course_id
      name
      subject
      grade
      school_year
      status
      on_monday
      on_tuesday
      on_wednesday
      on_thursday
      on_friday
      on_saturday
      on_sunday
    }
  }
`;

// 创建课程
export const CREATE_COURSE = gql`
  mutation CreateCourse($name: String!, $subject: String!, $grade: Int!, $school_year: Int, $status: CourseStatus!, $on_monday: Boolean, $on_tuesday: Boolean, $on_wednesday: Boolean, $on_thursday: Boolean, $on_friday: Boolean, $on_saturday: Boolean, $on_sunday: Boolean) {
    createCourse(name: $name, subject: $subject, grade: $grade, school_year: $school_year, status: $status, on_monday: $on_monday, on_tuesday: $on_tuesday, on_wednesday: $on_wednesday, on_thursday: $on_thursday, on_friday: $on_friday, on_saturday: $on_saturday, on_sunday: $on_sunday) {
      course_id
      name
      subject
      grade
      school_year
      status
      on_monday
      on_tuesday
      on_wednesday
      on_thursday
      on_friday
      on_saturday
      on_sunday
    }
  }
`;

// 更新课程
export const UPDATE_COURSE = gql`
  mutation UpdateCourse($course_id: ID!, $name: String, $subject: String, $grade: Int, $school_year: Int, $status: CourseStatus, $on_monday: Boolean, $on_tuesday: Boolean, $on_wednesday: Boolean, $on_thursday: Boolean, $on_friday: Boolean, $on_saturday: Boolean, $on_sunday: Boolean) {
    updateCourse(course_id: $course_id, name: $name, subject: $subject, grade: $grade, school_year: $school_year, status: $status, on_monday: $on_monday, on_tuesday: $on_tuesday, on_wednesday: $on_wednesday, on_thursday: $on_thursday, on_friday: $on_friday, on_saturday: $on_saturday, on_sunday: $on_sunday) {
      course_id
      name
      subject
      grade
      school_year
      status
      on_monday
      on_tuesday
      on_wednesday
      on_thursday
      on_friday
      on_saturday
      on_sunday
    }
  }
`;

// 删除课程
export const DELETE_COURSE = gql`
  mutation DeleteCourse($course_id: ID!) {
    deleteCourse(course_id: $course_id) {
      course_id
    }
  }
`;

// 查詢單個課程及所有上課時間
export const GET_COURSE_SESSIONS = gql`
  query GetCourseSessions($course_id: ID!) {
    courseSessions(course_id: $course_id) {
      session_id
      start_at
      end_at
      school {
        school_id
        name
      }
      course {
        course_id
        name
      }
    }
}
`;

// 创建课程上课时间
export const CREATE_COURSE_SESSION = gql`
  mutation CreateCourseSession($input: CourseSessionInput!) {
    createCourseSession(input: $input) {
      session_id
      start_at
      end_at   
      school{
        school_id
        name
      }
      course{
        course_id
        name
      }
    }
  }
`;

// 更新課程上課時間
export const UPDATE_COURSE_SESSION = gql`
  mutation UpdateCourseSession($session_id: ID!, $input: CourseSessionInput!) {
    updateCourseSession(session_id: $session_id, input: $input) {
      session_id
      start_at
      end_at
      school{
        school_id
        name
      }
      course{
        course_id
        name
      }
    }
  }
`;

// 刪除課程上課時間
export const DELETE_COURSE_SESSION = gql`
  mutation DeleteCourseSession($session_id: ID!) {
    deleteCourseSession(session_id: $session_id) {
      session_id
    }
  }
`;

// 查詢一段時間內的所有上課時間
export const GET_CALENDAR_SESSIONS = gql`
  query GetCalendarSessions($startDate: DateTime!, $endDate: DateTime!, $viewType: CalendarViewType!) {
    calendarSessions(startDate: $startDate, endDate: $endDate, viewType: $viewType) {
      session_id
      start_at
      end_at
      school {
        school_id
        name
      }
      course {
        course_id
        name
        subject
      }
      students{
        student_id
        name
      }
      absentStudents {
        student_id
        name
      }
      completedMakeupClassStudents {
        student_id
        name
      }
    }
  }
`;

// 用户登录
export const LOGIN = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      token
      user {
        user_id
        username
        role
      }
    }
  }
`;

// 用戶註冊
export const SIGNUP = gql`
  mutation Signup($input: LoginInput!) {
    signup(input: $input) {
      user_id
      username
      role
    }
  }
`;

// 更改用戶密碼
export const CHANGE_PASSWORD = gql`
mutation ChangePassword($currentPassword: String!, $newPassword: String!) {
  changePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
    user_id
  }
}
`;

// 查询課程的一個上課時間與學生出勤狀況
export const GET_SESSION = gql`
  query GetSession($session_id: ID!) {
    session(session_id: $session_id) {
      session_id
      start_at
      end_at
      school {
        school_id
        name
      }
      course {
        course_id
        name
        students {
          status
          student {
            student_id
            name
          }
        }
      }
      attendances {
        student_id
        status
        note
        student {
          student_id
          name
        }
      }
    }
  }
`;

//查詢一課程的所有註冊學生
export const GET_STUDENTS_IN_COURSE = gql`
  query GetStudentsInCourse($course_id: ID!) {
    studentsInCourse(course_id: $course_id) {
      student_id
      course_id
      status
      student {
        student_id
        name
      }
    }
  }
`;

// 查詢一學生的所有課程
export const GET_COURSES_FOR_STUDENT = gql`
  query GetCoursesForStudent($student_id: ID!) {
    coursesForStudent(student_id: $student_id) {
      course_id
      status
      course {
        course_id
        name
        subject
      }
    }
  }
`;

// 創建一個學生的課程關聯(StudentCourse) Enrollment
export const CREATE_STUDENT_COURSE = gql`
  mutation CreateStudentCourse($student_id: ID!, $course_id: ID!, $status: String) {
    createStudentCourse(student_id: $student_id, course_id: $course_id, status: $status) {
      student_id
      course_id
      status
    }
  }
`;

// 更新一個學生的課程註冊(StudentCourse)
export const UPDATE_STUDENT_COURSE = gql`
  mutation UpdateStudentCourse($student_id: ID!, $course_id: ID!, $status: String) {
    updateStudentCourse(student_id: $student_id, course_id: $course_id, status: $status) {
      student_id
      course_id
      status
    }
  }
`;

// 刪除一個學生的課程註冊(StudentCourse)
export const DELETE_STUDENT_COURSE = gql`
  mutation DeleteStudentCourse($student_id: ID!, $course_id: ID!) {
    deleteStudentCourse(student_id: $student_id, course_id: $course_id) {
      student_id
      course_id
    }
  }
`;

// 查询所有考勤记录
export const GET_ATTENDANCES = gql`
  query GetAttendances {
    attendances {
      student_id
      session_id
      status
    }
  }
`;

// 创建考勤记录
export const CREATE_ATTENDANCE = gql`
  mutation CreateAttendance($student_id: ID!, $session_id: ID!, $status: String!) {
    createAttendance(student_id: $student_id, session_id: $session_id, status: $status) {
      student_id
      session_id
      status
    }
  }
`;

// 創建多筆考勤記錄
export const BULK_CREATE_ATTENDANCE = gql`
  mutation BulkCreateAttendance($inputs: [AttendanceInput!]!) {
    bulkCreateAttendance(inputs: $inputs) {
      student_id
      session_id
      status
    }
  }
`;

// 更新多筆考勤記錄
export const BULK_UPDATE_ATTENDANCE = gql`
  mutation BulkUpdateAttendance($inputs: [AttendanceInput!]!) {
    bulkUpdateAttendance(inputs: $inputs) {
      student_id
      session_id
      status
    }
  }
`;

// 篩除考勤記錄
export const DELETE_ATTENDANCE = gql`
  mutation DeleteAttendance($student_id: ID!, $session_id: ID!) {
    deleteAttendance(student_id: $student_id, session_id: $session_id) {
      student_id
      session_id
    }
  }
`;
 
// 查询所有缴费记录
export const GET_PAYMENTS = gql`
  query GetPayments {
    payments {
      payment_id
      student_id
      course_id
      start_at
      end_at
      method
      total
    }
  }
`;

// 创建缴费记录
export const CREATE_PAYMENT = gql`
  mutation CreatePayment($student_id: Int!, $course_id: Int!, $start_at: DateTime!, $end_at: DateTime!, $method: String!, $total: Float!) {
    createPayment(student_id: $student_id, course_id: $course_id, start_at: $start_at, end_at: $end_at, method: $method, total: $total) {
      payment_id
      student_id
      course_id
      start_at
      end_at
      method
      total
    }
  }
`;

// 查询一個上課時間的所有补课预约
export const GET_MAKEUP_CLASSES_BY_SESSION = gql`
  query GetMakeupClasses($session_id: ID!) {
    makeupClassesBySession(session_id: $session_id) {
      id
      student_id
      session_id
      school_id
      start_at
      end_at
      status
      student {
        student_id
        name
      }
      staff {
        staff_id
        name
      }
      school {
        school_id
        name
      }
      session {
        course {
          name
          subject
        }
      }
    }
    # staff {
    #   staff_id
    #   name
    # }
    schools {
      school_id
      name
    }
  }
`;

// 查詢所有補課預約
export const GET_MAKEUP_CLASSES = gql`
  query GetMakeupClasses {
    makeupClasses {
      id
      student_id
      session_id
      school_id
      start_at
      end_at
      status
    }
  }
`;

// 创建补课预约
export const CREATE_MAKEUP_CLASS = gql`
  mutation CreateMakeupClass($student_id: Int!, $session_id: Int!, $school_id: Int!, $start_at: DateTime!, $end_at: DateTime!, $status: String!) {
    createMakeupClass(student_id: $student_id, session_id: $session_id, school_id: $school_id, start_at: $start_at, end_at: $end_at, status: $status) {
      id
      student_id
      session_id
      school_id
      start_at
      end_at
      status
    }
  }
`;

// 更新多筆補課預約
export const BULK_UPDATE_MAKEUP_CLASS = gql`
  mutation BulkUpdateMakeupClass($inputs: [MakeupClassInput!]!) {
    bulkUpdateMakeupClass(inputs: $inputs) {
      id
      student_id
      session_id
      status
      start_at
      end_at
      staff_id
      school_id
    }
  }
`;

// 查詢所有的課程諮詢
export const GET_COURSE_INQUIRIES = gql`
  query GetCourseInquiries {
    courseInquiries {
      id
      course_id
      course_title
      student_name
      school
      grade
      referrer
      parent_name
      contact_method
      contact_time
      line_id
      phone
      notes
      created_at
      status
    }
  }
`;

// 創建課程諮詢
export const CREATE_COURSE_INQUIRY = gql`
  mutation CreateCourseInquiry($input: CourseInquiryInput!) {
    createCourseInquiry(input: $input) {
      id
      course_id
      course_title
      student_name
      status
      created_at
    }
  }
`;

// 更新課程諮詢
export const UPDATE_COURSE_INQUIRY = gql`
  mutation UpdateCourseInquiry($id: ID!, $input: CourseInquiryInput!) {
    updateCourseInquiry(id: $id, input: $input) {
      id
      course_id
      course_title
      student_name
      status
    }
  }
`;

// 刪除課程諮詢
export const DELETE_COURSE_INQUIRY = gql`
  mutation DeleteCourseInquiry($id: ID!) {
    deleteCourseInquiry(id: $id) {
      id
    }
  }
`;

// Exam 相關查詢
// 查詢所有考試
export const GET_EXAMS = gql`
  query GetExams {
    exams {
      exam_id
      name
      authority
      type
      subject
      grade
      exam_date
      full_score
      average_score
      description
      school_year
      semester
      session_id
      session {
        session_id
        course {
          course_id
          name
          subject
        }
      }
      student_scores {
        id
        student_id
        student {
          student_id
          name
        }
        score
        percentage
        grade
        rank
      }
    }
  }
`;

// 查詢單個考試及其學生分數
export const GET_EXAM = gql`
  query GetExam($exam_id: ID!) {
    exam(exam_id: $exam_id) {
      exam_id
      name
      authority
      type
      subject
      grade
      exam_date
      full_score
      average_score
      description
      school_year
      semester
      session_id
      session {
        session_id
        course {
          course_id
          name
          subject
        }
      }
      student_scores {
        id
        student_id
        student {
          student_id
          name
        }
        score
        percentage
        grade
        rank
        notes
      }
    }
  }
`;

// 创建考試
export const CREATE_EXAM = gql`
  mutation CreateExam($input: ExamInput!) {
    createExam(input: $input) {
      exam_id
      name
      authority
      type
      subject
      grade
      exam_date
      full_score
      description
      school_year
      semester
      session_id
    }
  }
`;

// 更新考試
export const UPDATE_EXAM = gql`
  mutation UpdateExam($exam_id: ID!, $input: ExamInput!) {
    updateExam(exam_id: $exam_id, input: $input) {
      exam_id
      name
      authority
      type
      subject
      grade
      exam_date
      full_score
      description
      school_year
      semester
      session_id
    }
  }
`;

// 刪除考試
export const DELETE_EXAM = gql`
  mutation DeleteExam($exam_id: ID!) {
    deleteExam(exam_id: $exam_id) {
      exam_id
    }
  }
`;

// StudentExamScore 相關查詢
// 創建學生考試分數
export const CREATE_STUDENT_EXAM_SCORE = gql`
  mutation CreateStudentExamScore($input: StudentExamScoreInput!) {
    createStudentExamScore(input: $input) {
      id
      student_id
      exam_id
      score
      percentage
      grade
      rank
      notes
    }
  }
`;

// 更新學生考試分數
export const UPDATE_STUDENT_EXAM_SCORE = gql`
  mutation UpdateStudentExamScore($id: ID!, $input: StudentExamScoreInput!) {
    updateStudentExamScore(id: $id, input: $input) {
      id
      student_id
      exam_id
      score
      percentage
      grade
      rank
      notes
    }
  }
`;

// 刪除學生考試分數
export const DELETE_STUDENT_EXAM_SCORE = gql`
  mutation DeleteStudentExamScore($id: ID!) {
    deleteStudentExamScore(id: $id) {
      id
    }
  }
`;